import { Button, H1, H2, Paragraph } from '@flysas-tech/react-components';
import { Form } from '@remix-run/react';

/**
 * Validates if the user is authenticated, if not, redirects to the login page.
 * @param {import('@adg-octopus/functions').FunctionArgs} parameters action arguments
 * @returns {ReturnType<import('@adg-octopus/functions').AppContext<null>['auth']['isAuthenticated']>}} A promise that resolves to the user object
 */
export function loader({ context, request }) {
  return context.auth.isAuthenticated({
    request,
    options: {
      successRedirect: '/',
    },
  });
}

export default function Login() {
  return (
    <div className="flex w-full h-full justify-center items-center">
      <div className="flex flex-col gap-4">
        <H2 className="text-xl font-bold lowercase">
          <span className="uppercase">SAS O</span>
          ctopus
        </H2>
        <div className="border-t border-grey-70" />
        <H1 className="text-7xl">WELCOME</H1>
        <Paragraph>Log in to access your admin and backoffice tools.</Paragraph>
        <Form action="/auth/auth0" method="post">
          <Button type="submit" variant="primary" size="large">
            Login
          </Button>
        </Form>
      </div>
    </div>
  );
}
